module.exports = __webpack_public_path__ + "b1239d459bc64c407bc711d20f51ab82.pdf";